import ApiDatabase from 'server';

// Calls of the prospection day. Each one returns a Promise; a rejection keeps
// the axios error, whose response.data.errorCode is read by helper/prospectionErrors.js.
// ApiDatabase is read at call time, so that a test's mock of server/index.js is the one called.
const call = (method, body) =>
  new Promise((resolve, reject) => {
    ApiDatabase[method](body, resolve, reject);
  });

export const openDaySession = () => call('openCrmDaySession', {});

export const getCallDay = () => call('getCrmCallDay', {});

export const getGlobalList = () => call('getCrmGlobalList', {});

export const addToCallDay = ({ companyId, sessionId }) =>
  call('addCrmCallToDay', sessionId ? { companyId, sessionId } : { companyId });

export const listProspects = () => call('getCrmProspects', {});

export const removeFromCallDay = ({ callbackId }) => call('removeCrmCallFromDay', { callbackId });

// The undo object is sent back exactly as the api gave it.
export const restoreToCallDay = (undo) => call('restoreCrmCallToDay', undo);

// The people of the CRM ({ id, firstname, lastname, role }): the commercials
// (510) are the ones a prospect can be given to.
export const listTeam = () => call('getCrmTeam', {});

export const createProspect = ({ fields, addToday }) =>
  call('createCrmProspect', { fields, addToday });

export const checkSirets = async (sirets) => {
  if (!sirets?.length) return [];
  const { followed } = await call('checkCrmProspectSirets', { sirets });
  return followed ?? [];
};

// Only the fields of the contract are sent; an empty callbackId or sessionId is left out
// (a call opened off the list closes no callback).
export const confirmCall = ({
  companyId,
  callbackId,
  sessionId,
  result,
  note,
  contactName,
  followUp,
}) =>
  call('confirmCrmCall', {
    companyId,
    ...(callbackId ? { callbackId } : {}),
    ...(sessionId ? { sessionId } : {}),
    result,
    note: note ?? '',
    ...(contactName ? { contactName } : {}),
    ...(followUp ? { followUp } : {}),
  });

// Calls of the company, most recent first.
export const getCallHistory = async (companyId) => {
  const { calls } = await call('getCrmCallHistory', { companyId });
  return calls ?? [];
};
